import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const HRCalender = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("HR Calendar"));
  }, []);

  const [HRCalender, setHRCalender] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Code: { text: "Code", visible: true },
    Name: { text: "Name", visible: true },
    StartDate: { text: "Start Date", align: "center", visible: true },
    EndDate: { text: "End Date", align: "center", visible: true },
    WorkingDays: { text: "Payable Days", align: "center", visible: true },
  };

  const handleEdit = (id) => {
    console.log("Check ID", id);
    navigate(`/hrCalendar/edit/${id.ID}`);
  };

  const handleAddForm = () => {
    navigate("/hrCalendar/add");
  };

  const formatDateString = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const fetchHRCalender = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster`);
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const calenderData = response?.data?.header;
        const updatedData = calenderData?.reverse()?.map((item) => ({
          ...item,
          StartDate: formatDateString(item.StartDate),
          EndDate: formatDateString(item.EndDate),
        }));
        setHRCalender(updatedData);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };

  useEffect(() => {
    fetchHRCalender();
  }, []);
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <Dynamic_PR_table
                data={HRCalender}
                columns={columns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                isSorting={true}
                isApiStatus={apiStatus}
                isRequiredStatus={true}
                isActionRequired={true}
                handleIcon1={handleEdit}
                isAddNewBtnRequired={true}
                handleAddNew={handleAddForm}
                add
                more
                function
                icons={{
                  Icon1: <i class="bi bi-pencil-square icons"></i>,
                }}
              />
            </div>
          </div>
        </div>
    </>
  );
};

export default HRCalender;
